export class MessageI18n {
    _message;
    _placeholders;

    static handler = (message, placeholders) =>
        message.replace(
            /{\w+}/g,
            (placeholder) => placeholders[placeholder.substring(1, placeholder.length - 1)] || placeholder
        );

    constructor(message, placeholders) {
        this._message = message;
        this._placeholders = placeholders;
    }

    toString() {
        return this.constructor.handler(this._message, this._placeholders);
    }

    toJSON() {
        return this.toString();
    }
}